export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=406b061669f8367e6ae405f9b26f10cd0f2b37a151&name=revalidateCommunity!'